import { ClientResponseDto } from '../dto/auth/client-response-dto';
import { ClientModel } from '../interface/auth/client-model';

export class ClientMapper {
    public mapDtoToModel(dto: ClientResponseDto): ClientModel {
        return {
            id: dto.id,
            clientId: dto.clientId,
            clientSecret: dto.clientSecret,
            enabled: dto.enabled,
            name: dto.name,
            description: dto.description,
            accessTokenLifespan: dto.accessTokenLifespan,
        };
    }

    public mapModelToDto(model: ClientModel): ClientResponseDto {
        return {
            id: model.id,
            clientId: model.clientId,
            clientSecret: model.clientSecret,
            enabled: model.enabled,
            name: model.name,
            description: model.description,
            accessTokenLifespan: model.accessTokenLifespan,
        };
    }
}
